import { useQuery } from "react-query";

const fetchBrands = async () => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_REACT_APP_API_URL}/api/brands`
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    return response.json();
  } catch (error) {
    console.log(error);
  }
};

export const useBrands = () => {
  const { data, isLoading } = useQuery({
    queryKey: [`brands`],
    queryFn: () => fetchBrands(),
  });

  return {
    data,
    isLoading,
  };
};
